<template>
  <v-container :fluid="$vuetify.display.mdAndDown">
    <v-row>
      <v-spacer v-if="$vuetify.display.lgAndUp"/>
      <v-col
          md="2"
          lg="2"
      >
        <v-tabs
            v-model="tab"
            :direction="$vuetify.display.mdAndUp ? 'vertical' : 'horizontal'"
        >
          <v-tab value="#profile">
            <v-icon start="true">
              mdi-account
            </v-icon>
            Profile
          </v-tab>
          <v-tab value="#orders">
            <v-icon start="true">
              mdi-car-multiple
            </v-icon>
            Orders
          </v-tab>
          <v-tab value="#invoices">
            <v-icon start="true">
              mdi-receipt
            </v-icon>
            Invoices
          </v-tab>
          <v-tab value="#payments">
            <v-icon start="true">
              mdi-account-cash
            </v-icon>
            Payments
          </v-tab>
        </v-tabs>
      </v-col>
      <v-col
          md="10"
          lg="8"
      >
        <v-window v-model="tab">
          <v-window-item
              transition="false"
              reverse-transition="false"
              value="#profile"
          >
            <user-profile-view/>
          </v-window-item>
          <v-window-item
              transition="false"
              reverse-transition="false"
              value="#orders"
          >
            <user-car-requests-view/>
          </v-window-item>
          <v-window-item
              transition="false"
              reverse-transition="false"
              value="#invoices"
          >
            <user-invoices-view/>
          </v-window-item>
          <v-window-item
              transition="false"
              reverse-transition="false"
              value="#payments"
          >
            <payments-view/>
          </v-window-item>
        </v-window>
      </v-col>
      <v-spacer v-if="$vuetify.display.lgAndUp"/>
    </v-row>
  </v-container>
</template>

<script>
import PaymentsView from "@/views/PaymentsView.vue";
import UserProfileView from "@/views/UserProfileView.vue";
import UserCarRequestsView from "@/views/UserCarRequests/UserCarRequestsView.vue";
import UserInvoicesView from "@/views/UserInvoicesView.vue";

export default {
  name: "ProfileView",
  components: {UserInvoicesView, UserProfileView, UserCarRequestsView, PaymentsView},
  watch: {
    tab: function () {
      this.$router.replace({hash: this.tab})
    },
    $route: function () {
      this.tab = this.$route.hash === '' ? '#profile' : this.$route.hash
    }
  },
  data() {
    return {
      tab: '#profile',
    }
  },
  mounted() {
    this.tab = this.$route.hash === '' ? '#profile' : this.$route.hash
  }
}
</script>

<style scoped>

</style>